module.exports = __webpack_public_path__ + "img/dillon-wanner-FlewGATv_x0-unsplash.85268e7a.jpg";